import { useQuery } from '@tanstack/react-query';
import api from '../api';
import Jobs from '../pages/Jobs';

export default function JobProfileModal({ jobId, initialJob = null, onClose }) {
  const { data: jobs, isLoading } = useQuery({
    queryKey: ['jobs'],
    queryFn: () => api.get('/jobs').then(r => r.data),
    enabled: Boolean(jobId) && !initialJob
  });

  const job =
    initialJob?.id === jobId
      ? initialJob
      : (Array.isArray(jobs) ? jobs.find(j => j.id === jobId) : null);

  if (!jobId) return null;

  if (isLoading && !job) {
    return (
      <div className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4">
        <div className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm text-[hsl(var(--ds-fg))] shadow-xl">
          Loading job…
        </div>
      </div>
    );
  }

  if (!job) {
    return (
      <div
        className="fixed inset-0 z-[14000] bg-black/50 flex items-center justify-center p-4"
        onClick={onClose}
      >
        <div
          className="bg-[hsl(var(--ds-surface))] border border-[hsl(var(--ds-border))] rounded-xl px-6 py-4 text-sm shadow-xl max-w-sm"
          onClick={e => e.stopPropagation()}
        >
          <p className="text-[hsl(var(--ds-fg))] mb-3">Could not load this job.</p>
          <button
            type="button"
            className="px-3 py-1.5 text-sm border border-[hsl(var(--ds-border))] hover:bg-[hsl(var(--ds-muted))] rounded-lg"
            onClick={onClose}
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  return (
    <Jobs embedded embeddedEditId={jobId} initialJob={job} onEmbeddedClose={onClose} />
  );
}
